var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMobileDetection } from 'vue3-mobile-detection';
import { DROPDOWN_CLASSES, getOverlayClasses, getListContainerClasses, LIST_CLASSES, OPTION_CHECK_ICON_CLASSES, OPTION_BLANK_ICON_CLASSES, EMPTY_MESSAGE_CLASSES, PC_FILTER_CONTAINER, PC_FILTER, PC_FILTER_ICON_CONTAINER, TRANSITION_CLASSES, OPTION_GROUP_CLASSES, getOptionClasses, getRootClasses, getHeaderClasses, } from 'common/vue/PrimeVueConfig/Constants/select';
import { CHECKBOX_ICON_CLASSES, getBoxClasses, getInputClasses } from 'common/vue/PrimeVueConfig/Constants/checkbox';
var isMobile = useMobileDetection().isMobile;
export default {
    root: function (_a) {
        var props = _a.props, state = _a.state;
        return (__assign({}, getRootClasses(props, state)));
    },
    label: function (_a) {
        var props = _a.props;
        return ({
            class: [
                'tw-flex tw-items-center',
                'tw-text-md tw-leading-5',
                'tw-overflow-hidden tw-whitespace-nowrap tw-cursor-pointer',
                'tw-text-gray-800 dark:tw-text-white',
                'tw-transition tw-duration-200',
                props.display === 'chip' && (props === null || props === void 0 ? void 0 : props.modelValue) !== null ? 'tw-py-1 tw-px-1.5' : 'tw-px-3 tw-py-1',
            ],
        });
    },
    labelContainer: {
        class: 'tw-overflow-hidden tw-flex tw-flex-auto tw-cursor-pointer tw-relative [mask:linear-gradient(90deg,#0000,#000_0%_85%,#0000)]',
    },
    chipItem: {
        class: [
            'tw-text-sm',
            'tw-py-0.5 tw-pl-2 tw-pr-7 tw-mr-2 tw-relative tw-rounded-lg tw-bg-gray-200/70 tw-text-gray-950 dark:tw-bg-zinc-300',
            'tw-inline-flex tw-items-center',
            'hover:tw-bg-red-500 hover:tw-text-white',
            'tw-transition tw-duration-200',
        ],
    },
    dropdown: {
        class: DROPDOWN_CLASSES,
    },
    overlay: __assign({}, getOverlayClasses(isMobile())),
    listContainer: function (_a) {
        var props = _a.props;
        return (__assign({}, getListContainerClasses(isMobile(), Boolean(props.filter))));
    },
    list: {
        class: LIST_CLASSES,
    },
    option: function (_a) {
        var context = _a.context;
        return ({
            class: __spreadArray(__spreadArray([], __read(getOptionClasses(context)), false), [
                'tw-px-3 tw-py-2',
                '[word-break:break-word] tw-line-clamp-3',
                'tw-gap-x-2',
                {
                    'hover:tw-bg-primary-500/40 dark:hover:tw-bg-primary-500/60': context.selected,
                    'hover:tw-bg-gray-200/70 dark:hover:tw-bg-zinc-700/70': !context.selected && !context.focused,
                    'tw-bg-primary-500/20 dark:tw-bg-primary-500/40': context.selected && !context.focused,
                    'tw-bg-gray-200/70 dark:tw-bg-zinc-700/70': !context.selected && context.focused,
                    'tw-bg-primary-500/40 dark:tw-bg-primary-500/60': context.selected && context.focused,
                },
            ], false),
        });
    },
    optionGroup: {
        class: OPTION_GROUP_CLASSES,
    },
    optionCheckIcon: OPTION_CHECK_ICON_CLASSES,
    optionBlankIcon: OPTION_BLANK_ICON_CLASSES,
    emptyMessage: {
        class: EMPTY_MESSAGE_CLASSES,
    },
    header: function (_a) {
        var props = _a.props;
        return ({
            class: __spreadArray(__spreadArray([], __read(getHeaderClasses(isMobile(), props)), false), ['tw-flex tw-items-center tw-justify-between tw-gap-x-2'], false),
        });
    },
    itemCheckbox: {
        box: function (_a) {
            var props = _a.props, context = _a.context;
            return (__assign({}, getBoxClasses(props, context)));
        },
        input: {
            input: function (_a) {
                var props = _a.props;
                return (__assign({}, getInputClasses(props)));
            },
        },
        icon: {
            class: CHECKBOX_ICON_CLASSES,
        },
    },
    pcFilterContainer: PC_FILTER_CONTAINER,
    pcFilter: PC_FILTER,
    pcFilterIconContainer: PC_FILTER_ICON_CONTAINER,
    transition: TRANSITION_CLASSES,
};
